import * as React from "react";
import { useEffect, useState } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { usePreComponentCalls } from "components/layout/PreComponentLoad";
import { chevronDownIcon } from "@progress/kendo-svg-icons";
import { getTeams } from "api";
import { ComboBoxLabel } from "components/Dashboard";
import { useCurrentUser } from "services/currentUserService";
import { useCompany } from "services/companyService";
import { DateRange } from "./DateRange";
import { formatDateForAPI } from "./formatter";

export const FilterComponent = (props) => {
  const { data: user } = useCurrentUser();
  const INITIAL_STATE = {
    branchId: {
      branchName: "All",
      branchId: props?.allowAccessData?.accessAllBranches
        ? -2
        : props?.allowAccessData?.accessAllTeams
        ? props?.allowAccessData?.branches[0]?.branchId
        : -1,
    },
    teamId: { teamName: "All", teamID: -2 },
    feeEarnerRef: {
      display: user?.display || "All",
      userRef: user?.userRef || "All",
      active: null,
    },
  };
  const { data: company } = useCompany();
  const { handleCalls } = usePreComponentCalls();

  useEffect(() => {
    handleCalls("Filters");
  }, []);
  const startDate = new Date(company?.yearStartDate);
  let startOfWeek, endOfWeek;
  const dayOfWeek = startDate.getDay();
  startOfWeek = new Date(startDate);
  startOfWeek.setDate(
    startDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)
  );
  endOfWeek = new Date(startOfWeek);
  endOfWeek.setFullYear(startOfWeek.getFullYear() + 1);
  endOfWeek.setDate(endOfWeek.getDate() - 1);

  const [teamsData, setTeamsData] = useState([]);
  const [comboBoxState, setComboBoxState] = useState(INITIAL_STATE);
  const [initialLock, setInitialLock] = useState(true);
  const [duration, setDuration] = useState("");
  const [toDate, setToDate] = useState(endOfWeek);
  const [fromDate, setFromDate] = useState(startOfWeek);

  useEffect(() => {
    if (!initialLock) {
      props.updateFilters({
        feeEarnerRef: comboBoxState["feeEarnerRef"]?.userRef || user?.userRef,
        teamId: comboBoxState["teamId"]?.teamID,
        branch: comboBoxState["branchId"]?.branchId,
        ToDate: formatDateForAPI(toDate),
        FromDate: formatDateForAPI(fromDate),
        duration: duration,
      });
    }

    if (initialLock) setInitialLock(false);
  }, [comboBoxState, toDate, fromDate]);

  useEffect(() => {
    if (user) {
      setComboBoxState({
        ...comboBoxState,
        feeEarnerRef: {
          display: user?.display || "All",
          userRef: user?.userRef || "All",
          active: null,
        },
      });
    }
  }, [user]);

  const dataFetcher = async (e) => {
    try {
      const data = await getTeams();
      let dataToPass = data?.data?.data;
      setTeamsData([{ teamName: "All" }, ...dataToPass]);
    } catch (error) {}
  };
  useEffect(() => {
    dataFetcher();
  }, []);

  const DASHBOARD_FILTERS = props.component === "Dashboard";

  const handleDateChange = (newFromDate, newToDate, newDuration) => {
    setFromDate(newFromDate);
    setToDate(newToDate);
    setDuration(newDuration);
  };

  return (
    <div
      className={`d-flex flex-wrap ${
        props.component === "Graphs" && "flex-wrap"
      }`}
    >
      {props?.allowAccessData?.accessAllBranches && (
        <div
          className={`d-flex flex-column pe-3 ${
            DASHBOARD_FILTERS ? "col" : "col"
          } `}
        >
          {DASHBOARD_FILTERS ? (
            <ComboBoxLabel name="Branch" />
          ) : (
            <Label className="filter-font mb-1">Branch</Label>
          )}
          <ComboBox
            style={{
              width: "100%",
              height: "40px",
            }}
            data={props?.allowAccessData?.branches}
            textField={`branchName`}
            className="ps-2"
            svgIcon={chevronDownIcon}
            filterable={true}
            placeholder={"Search Branch"}
            value={comboBoxState["branchId"]}
            onChange={(e) => {
              if (e.value === null) {
                setComboBoxState({
                  ...comboBoxState,
                  branchId: { branchName: "All", branchId: -2 },
                });
                return;
              }
              setComboBoxState({ ...comboBoxState, branchId: e.value });
            }}
          />
        </div>
      )}

      {(!props?.allowAccessData?.accessAllTeams &&
        props?.allowAccessData?.branches[0]?.teams?.length > 1) ||
        (props?.allowAccessData?.accessAllTeams && (
          <div
            className={`d-flex flex-column pe-3 ${
              DASHBOARD_FILTERS ? "col" : "col"
            } `}
          >
            {DASHBOARD_FILTERS ? (
              <ComboBoxLabel name="Team" />
            ) : (
              <Label className="filter-font mb-1">Team</Label>
            )}
            <ComboBox
              style={{
                width: "100%", //DASHBOARD_FILTERS ? "250px" : "200px",
                height: "40px",
              }}
              data={
                props.allowAccessData?.branches?.filter(
                  (branch) =>
                    branch.branchId === comboBoxState["branchId"]?.branchId
                )[0]?.teams
              }
              svgIcon={chevronDownIcon}
              textField={"teamName"}
              value={comboBoxState["teamId"]}
              onChange={(e) => {
                if (e.value === null) {
                  setComboBoxState({
                    ...comboBoxState,
                    teamId: { teamName: "All", teamID: -2 },
                  });
                  return;
                }
                setComboBoxState({
                  ...comboBoxState,
                  teamId: e.value,
                });
              }}
              placeholder={"Search Team"}
            />
          </div>
        ))}

      {props?.allowAccessData?.accessAllFeeEarnersInTeam &&
        !props.disabledFeeEarner && (
          <div
            className={`d-flex flex-column pe-3 ${
              DASHBOARD_FILTERS ? "col" : "col"
            } `}
          >
            {DASHBOARD_FILTERS ? (
              <ComboBoxLabel name="Feeearner" />
            ) : (
              <Label className="filter-font mb-1">Fee Earner</Label>
            )}
            <ComboBox
              style={{
                width: "100%", //DASHBOARD_FILTERS ? "260px" : "200px",
                height: "40px",
              }}
              data={
                props.allowAccessData?.branches
                  ?.filter(
                    (branch) =>
                      branch.branchId === comboBoxState["branchId"]?.branchId
                  )[0]
                  ?.teams.filter(
                    (teams) => teams.teamID === comboBoxState["teamId"]?.teamID
                  )[0]
                  ?.feeEarners?.map((feeEarner) => ({
                    ...feeEarner,
                    display: `${feeEarner?.userRef} - ${feeEarner?.displayname}`,
                  })) || []
              }
              textField="display"
              filterable={true}
              className="ps-2"
              svgIcon={chevronDownIcon}
              placeholder={"Search Fee Earner"}
              value={comboBoxState["feeEarnerRef"]}
              onChange={(e) => {
                if (e.value === null) {
                  setComboBoxState({
                    ...comboBoxState,
                    feeEarnerRef: { display: "All", userRef: "ALL" },
                  });
                  return;
                }
                setComboBoxState({
                  ...comboBoxState,
                  feeEarnerRef: e.value,
                });
              }}
            />
          </div>
        )}

      {props.component === "Dashboard" && (
        <DateRange
          fromDate={fromDate}
          toDate={toDate}
          onDateChange={handleDateChange}
          yearStartDate={company?.yearStartDate}
          icon
        />
      )}
    </div>
  );
};
